
<template>
    <div v-if="showModel" class="edit-model">
        <div class="img-div">
            <div>{{title}}</div>
            <div class="close-img" @click="cancel"><i class="iconfont">&#xe641;</i></div>
        </div>
       
        <Form ref="formData" :model="formData" :rules="ruleCustom" :label-width="80">
            <FormItem label="标题" prop="title">
                <Input type="text" v-model="formData.title"></Input>
            </FormItem>
            <FormItem label="缩略图" prop="thumb" >
                <uploadImg
					ref="upImg"
					:action="action"
					:num="num"
					:hasUpload="hasUpload"
					@setThumbUrl="setSelected($event,'thumb')"
				></uploadImg>
            </FormItem>
            <FormItem label="时间范围" prop="sort" class="ivu-form-item-required">
                <DatePicker @on-change="setSelected($event,'timeArea')"  type="daterange"  placement="bottom" v-model="formData.timeArea"  placeholder="请选择时间范围" style="width: 200px"></DatePicker>
            </FormItem>
            <FormItem label="状态" prop="status" class="ivu-form-item-required">
                <RadioGroup v-model="formData.status">
                    <Radio label="1">正常</Radio>
                    <Radio label="2">关闭</Radio>
                </RadioGroup>
            </FormItem>
            <FormItem label="排序" prop="sort">
                <Input type="text" v-model="formData.sort"></Input>
            </FormItem>
            <FormItem label="详情介绍" prop="detail">
                <Input type="text" v-model="formData.detail"></Input>
            </FormItem>
            <FormItem>
                <Button :disabled="disabled" type="primary" @click="subData('formData')">确定</Button>
            </FormItem>
        </Form>
    </div>
</template>
<script>
/**
 * 弹框
 * @param showModel boolean 对话框开关 true false
 * @param fn function 回调函数
 * @param type Number 类型 1添加 2编辑
 * @param editFormData Object 编辑时的数据
 */
import common from "@/common/common";
import uploadImg from "@/views/common/upload.vue";
export default {
  props: {
    showModel: Boolean,
    fn: Function,
    type: Number,
    editFormData: Object
  },
  name: "Model1",
  components: {
      uploadImg
  },
  data() {
    return {
      //上传图片 start
      action: this.config.urlArray.questionUploadThumb, //上传图片接口
      num: 1, //图片上传数量
      hasUpload: [], //已上传图片
      //上传图片 end
      title: "添加/编辑",
      disabled: false,
      defaultData: {
        id: "",
        title: "",
        thumb: "",
        detail: "",
        start_time: "",
        end_time: "",
        status: "1",
        sort: "100",
        timeArea: ["", ""]
      },
      formData: {},
      ruleCustom: {
        //验证
        title: [{ required: true, message: "问题必须填写", trigger: "blur" }],
        thumb: [{ required: true, message: "缩略图必须上传", trigger: "blur" }],
       
        sort: [{ required: true, message: "排序必须填写", trigger: "blur" }],
        detail: [{ required: true, message: "详情必须填写", trigger: "blur" }]
      }
    };
  },
  watch: {
    showModel(val) {
      if (val) {
        if (this.type && this.type == 2) {
          this.editForm();
        }
        if (this.type && this.type == 1) {
          this.formData = this.defaultData;
        }
      }
    }
  },
  methods: {
    setSelected(data, key) {
      console.log(data);
      this.formData[key] = data;
    },
    editForm() {
      for (let key in this.defaultData) {
        this.formData[key] =  this.editFormData[key] instanceof Array ||  this.editFormData[key] instanceof Object ? this.editFormData[key] : String(this.editFormData[key]);
        if (!this.editFormData[key]) {
          this.formData[key] = "";
        }
        this.formData.timeArea = [this.formData.start_time,this.formData.end_time]

        this.$nextTick(() => {
            let thumbUpload = [{
            status:'finished',
            response:{data:this.formData.thumb}
            }]
            this.$refs.upImg.setHasUpload(thumbUpload)//为上传组件付默认值
        })
      }
    },
    subData(name) {
      //提交表单
      this.$refs[name].validate(valid => {
        if (valid) {
          this.disabled = true;
          this.formData.start_time = this.formData.timeArea[0]
          this.formData.end_time = this.formData.timeArea[1]
          this.axios
            .post(this.config.urlArray.questionStore, this.formData)
            .then(result => {
              common.ajaxMsg(
                result.data,
                true,
                () => {
                  //提交表单后的回调处理
                  this.resetForm(); //重置表单
                  this.fn();
                },
                () => {
                  this.disabled = false;
                }
              );
            })
            .catch(err => {
              common.msg("error", "提交失败", () => {
                this.disabled = false;
              });
            });
        }
      });
    },
    cancel() {
      //对话框关闭
      this.$emit("update:showModel", false);
      this.resetForm();
      this.fn();
    },
    setThumbUrl(url) {
      //获取图片上传后的路径
      this.formData.thumb = url;
    },
    resetForm() {
      this.formData = this.defaultData;
      //重置表单
      this.formData.id = '';
      this.$refs.formData.resetFields(); //重置表单
      this.disabled = false; //恢复提交按钮为激活状态
        console.log(this.defaultData)
      console.log('清除数据',this.formData)
    }
  }
};
</script>
<style lang='scss' scoped>
.edit-model {
  position: relative;
  .img-div {
    width: 100%;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 45px;
    div {
      font-weight: bold;
      font-size: 15px;
    }
  }
  .close-img {
    border: 1px solid #fd6363;
    display: inline-block;
    line-height: 100%;
    border-radius: 100%;
    padding: 5px;
    color: #f00;
    right: 10px;
    top: 10px;
    z-index: 3;
    cursor: pointer;
  }
  .close-img:hover {
    transform: scale(1.1);
    transition: all 0.3s;
  }
}
</style>